export const HOTJAR_CONFIG = {
  siteId: 502343, // STEMI
  version: 6,
  whitelistedNamespaces: ['brazil'] as string[],
  whitelistedSchoolIds: [] as string[],
  blacklistedDomains: ['@stemi.education'] as string[],
} as const; 